import { dispatcher } from '../dispatcher/dispatcher';
import Constants from '../constants/constants';
import { storeUtils } from './util';
const { ActionTypes } = Constants;
var _events = new storeUtils.EventEmitter();
var CHANGE_EVENT = 'change';

//the entire list of subdivisions returned from the mainframe (all of the GTB enabled subs)
var _subdivisionsList = [];
//the grit enabled subs
var _gritEnabledSubdivisions = [];
//PTC Rs subdivisions
let _ptcRsSubdivisions = [];
//the list of subs that are available in the sub dropdown in the header
var _selectableSubs = [];
//the selected subdivision
var _selectedSubdivision = 0;
//all the data about this subdivision
var _subdivisionData;
//separate data store for Form C sub data
let _formCSubData;
//flag determining if a sub is selected
var _subSelected = false;
let _divisions = [];

var dispatchToken = dispatcher.register(function (action) {

    //this action comes from the dispatcher
    switch (action.type) {

        case ActionTypes.USER_CHANGED:
            _subSelected = false;
            _selectedSubdivision = 0;
            if (action.role.indexOf(Constants.Roles.DISPATCHER) != 0) {
                _selectableSubs = _gritEnabledSubdivisions;//show the entire list of subs
            }
            else {
                //If they are changing to a dispatcher default them to none
                _selectableSubs = null;
            }
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.SET_USER_ROLE:
            if (action.user.roles.indexOf(Constants.Roles.DISPATCHER) === 0) {
                //If they are a dispatcher default them to none
                _selectableSubs = null;
            }

            _events.trigger(CHANGE_EVENT);
            break;

        //initial load of list from server
        case ActionTypes.SUBDIVISION_LIST_LOADED:
            _subdivisionsList = action.subs;
            //filter out the subs that are not grit enabled
            _gritEnabledSubdivisions = action.subs.filter(function (item) {
                return item.gritEnabled;
            });
            _selectableSubs = _gritEnabledSubdivisions;
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.DIVISION_LIST_LOADED:
            _divisions = action.divisions;
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.PTC_SUBDIVISION_LIST_LOADED:
            _ptcRsSubdivisions = action.subs;

            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.SUBDIVISION_CHANGED:
            _subdivisionData = {
                "defaultDirection": "",
                "defaultTimezone": "",
                "fullName": "",
                "milePostRangeList": [],
                "name": "",
                "usesGTB": true
            };
            _formCSubData = {
                "defaultDirection": "",
                "defaultTimezone": "",
                "fullName": "",
                "milePostRangeList": [],
                "name": "",
                "usesGTB": true
            };
            _selectedSubdivision = action.selectedSub;
            if (_selectedSubdivision === "showall") {
                _subSelected = false;
            }
            else {
                _subSelected = true;
            }

            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.SUBDIVISION_DETAILS_LOADED:
            _subdivisionData = action.details;
            _formCSubData = action.details;
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.FORM_C_SUBDIVISION_DETAILS_LOADED:
            _formCSubData = action.details;
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.TERRITORY_CHANGED:
            if (!action.autoSelected) {
                _subSelected = false;
                _selectedSubdivision = 0;
            }
            //if the selected 'All', then update the sub list to show everything
            if (action.selectedTerritory === '0') {
                _selectableSubs = _gritEnabledSubdivisions;
            }
            else if (action.selectedTerritory === '1') {
                _selectableSubs = null;
            }
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.TERRITORY_DETAILS_LOADED:
            //once a territories details have loaded we need to update _selectableSubs
            _selectableSubs = action.details.territorySegmentList.map(function (t) {
                return { name: t.subdivision.trim(), gritEnabled: t.gritEnabled }
            });
            _selectableSubs = _selectableSubs.filter(function (item) {
                return item.gritEnabled;
            });

            _events.trigger(CHANGE_EVENT);
            break;
        case ActionTypes.TERRITORY_DETAIL_FAILED_LOAD:
            _selectableSubs = _gritEnabledSubdivisions;
            _events.trigger(CHANGE_EVENT);

            break;
        case ActionTypes.TAB_CHANGED:
            _formCSubData = _subdivisionData; //On a tab change, reset the sub details
            _events.trigger(CHANGE_EVENT);
            break;
        default:
        //no op
    }
});//end of dispatch token


//public api
export const subdivisionStore = {
    dispatchToken,
    subscribe: _events.on,
    unsubscribe: _events.off,
    getSelectedSub: function () {
        return _selectedSubdivision;
    },
    getSubList: function () {
        return _selectableSubs;
    },
    getDivList: function () {
        return _divisions;
    },
    getPtcSubdivisionList: function () {
        return _ptcRsSubdivisions;
    },
    getEntireSubList: function () {
        return _subdivisionsList;
    },
    getSubData: function () {
        return _subdivisionData;
    },
    getFormCSubData: function () {
        return _formCSubData;
    },
    isSubSelected: function () {
        return _subSelected;
    },
};
